// src/cmsApi.ts
import axios from "axios";
import { getLocaleFromPath } from "../../i18n/config";
import { getRegionCmsLocale, getRegionSlugPrefix } from "../constants";

const CMS_LOCALE_MAP: Record<string, string> = {
    fi: "fi-FI",
    en: "en",
    sv: "sv-SE",
};

export function getCmsLocale(): string {
    const region = localStorage.getItem("region");
    if (region) return getRegionCmsLocale(region);

    const lang = getLocaleFromPath();
    return CMS_LOCALE_MAP[lang] || "fi-FI";
}

/** Prefix a CMS slug with the locale prefix (e.g. "tablet" → "en-tablet" for en) */
export function getLocalizedSlug(slug: string): string {
    const region = localStorage.getItem("region");
    if (region) {
        const slugPrefix = getRegionSlugPrefix(region);
        return slugPrefix ? `${slugPrefix}-${slug}` : slug;
    }

    const lang = getLocaleFromPath();
    if (lang === "fi") return slug;
    return `${lang}-${slug}`;
}

const cmsApi = axios.create({
    baseURL: `${process.env.REACT_APP_CMS_ENDPOINT}/api`,
});

cmsApi.interceptors.request.use((config: any) => {
    const token = process.env.REACT_APP_CMS_API_TOKEN;
    config.headers["Authorization"] = `Bearer ${token}`;

    const locale = getCmsLocale();
    const separator = config.url?.includes("?") ? "&" : "?";
    config.url = `${config.url}${separator}locale=${locale}`;

    return config;
});

export default cmsApi;
